import _BaseAPIService from "../../_BaseAPIService";

const apiService = _BaseAPIService.instance;
const slug = "api";
const SalesReportService = {
  // Define your API functions here
  returnBill: async (data) => {
    const response = await apiService.post(`/${slug}/returnbilllogs`, data);
    return response.data;
  },
  returnBillList: async () => {
    const response = await apiService.get(`/${slug}/returnbilllogs`);
    return response.data;
  },
  update: async (id, updatedData) => {
    try {
      const response = await apiService.put(
        `/${slug}/billinglogs/${id}`,
        updatedData
      );
      return response.data;
    } catch (error) {
      console.error("Error updating ratecard:", error);
      throw error;
    }
  },
  getList: async () => {
    const response = await apiService.get(`/${slug}/billinglogs`);
    return response.data;
  },
  getCustomerDetail: async (id) => {
    const response = await apiService.get(`/${slug}/billinglogs/${id}`);
    return response.data;
  },
  getCustomerBooking: async (id) => {
    const response = await apiService.get(`/customers/${id}/bookings`);
    return response.data;
  },

  guestUserList: async () => {
    const response = await apiService.get("/guestusers");
    return response.data;
  },
  getGuestDetail: async (id) => {
    const response = await apiService.get(
      `/billinglogs/guest/withorderdetail/${id}`
    );
    return response.data;
  },
  delete: async (id) => {
    const response = await apiService.delete(`/billinglogs/${id}`);
    return response.data;
  },

  categorywise: async ({ startDate, endDate }) => {
    // Build query params dynamically
    const params = new URLSearchParams();

    if (startDate) params.append("startDate", startDate);
    if (endDate) params.append("endDate", endDate);

    const response = await apiService.get(
      `/${slug}/salesreport/categorywise?${params.toString()}`
    );

    return response.data;
  },
  itemwise: async ({ startDate, endDate, categoryId }) => {
    // Build query params dynamically
    const params = new URLSearchParams();

    if (startDate) params.append("startDate", startDate);
    if (endDate) params.append("endDate", endDate);
    if (categoryId) params.append("categoryId", categoryId);
    const response = await apiService.get(
      `/${slug}/salesreport/itemwise?${params.toString()}`
    );

    return response.data;
  },

  getSalesDetail: async (refId) => {
    const response = await apiService.get(`/${slug}/menuorder/refrencenumber/${refId}`);
    return response.data;
  },
};

export default SalesReportService;
